/* eslint-disable */

import React, { useState, useEffect, useMemo } from 'react'
import BtnClose from '../../../components/BtnClose'
import DatePicker from 'react-datepicker'
import styled from '@emotion/styled'
import Select from 'react-select'
import { FiFilter } from 'react-icons/fi'
import { useDistributors, useRegions, useIndustries, useBUs, useReportFilters, useIndustriesName, usePlataformas } from '../../../../app/modules/auth'
import * as API from '../../../api'

const Style = styled.div`
  .modal-container {
    width: 100%;
    max-width: 1040px;
    margin: 54px auto 0 auto;
    background: #f5f8fc;
    border-radius: 18px;
    box-shadow: 0 12px 35px 0 #2f39531e;
    overflow: hidden;
    border: 1.5px solid #e0e5f2;
  }
  .modal-header-area {
    background: #f0f4fa;
    padding: 25px 44px 15px 44px;
    border-radius: 18px 18px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1.5px solid #e0e5f2;
  }
  .header-title {
    color: #264073;
    font-size: 22px;
    font-weight: 800;
    display: flex;
    align-items: center;
    gap: 10px;
    letter-spacing: 0.015em;
    line-height: 1.04;
  }
  .close-btn {
    margin-left: 12px;
    background: transparent;
    border-radius: 40px;
    transition: background .15s;
    &:hover { background: #ecf0f7 }
  }
  .modal-body-content {
    padding: 36px 45px 40px 45px;
    background: #f5f8fc;
    border-radius: 0 0 18px 18px;
  }
  .form-fields-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 22px 28px;
    width: 100%;
    @media (max-width: 760px) { grid-template-columns: 1fr; gap: 16px 0; }
  }
  .form-group {
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    width: 100%;
    margin: 0;
  }
  .form-label {
    font-size: 15.2px;
    font-weight: 600;
    color: #254880;
    margin-bottom: 7px;
    margin-left: 1px;
    letter-spacing: 0.025em;
    text-align: left;
  }
  .form-input,
  .form-control,
  .react-datepicker-wrapper input {
    border: 1.1px solid #d9e4fd !important;
    background: #f6fafd !important;
    border-radius: 7px !important;
    font-size: 15.4px;
    line-height: 1.37;
    padding: 9px 13px;
    color: #2b3352 !important;
    transition: border-color .18s;
    outline: none;
    margin-bottom: 0 !important;
    font-weight: 500;
    min-height: 38px;
    width: 100%;
    box-shadow: none;
  }
  .form-input:focus,
  .react-datepicker__input-container input:focus {
    border-color: #3d7efd !important;
    background: #f0f6fe !important;
  }
  .multi-select .react-select__control {
    min-height: 38px;
    border-radius: 7px;
    border: 1.1px solid #d9e4fd;
    font-size: 15.2px;
    color: #223773;
    background: #f6fafd;
    transition: border-color .18s;
    box-shadow: none;
    &--is-focused {
      border-color: #3d7efd;
      background: #e6f0fe;
    }
  }
  .radio-row {
    display: flex;
    gap: 11px;
    align-items: center;
    margin-top: 2px;
    flex-wrap: wrap;
  }
  .radio-item {
    margin: 0 5px 0 0;
  }
  .radio-item input[type="radio"] {
    display: none;
  }
  .radio-item label {
    display: inline-block;
    cursor: pointer;
    font-size: 15.2px;
    font-weight: 500;
    color: #274798;
    padding: 6.2px 20px;
    border-radius: 17px;
    border: 1.2px solid #d6e6fa;
    background: transparent;
    margin-bottom: 0;
    transition: color .12s, background .12s, border-color .12s;
    line-height: 1.08;
  }
  .radio-item input[type="radio"]:checked + label {
    background: #e4ecfa;
    border-color: #3570e6;
    color: #1f3f80;
    font-weight: 750;
  }
  .radio-item input[type="radio"]:not(:checked):hover + label {
    background: #edf3fe;
    border-color: #337aec;
    color: #2554b3;
  }
  .filter-btn {
    margin-top: 34px;
    width: 100%;
    min-height: 47px;
    font-size: 17px;
    font-weight: 700;
    border-radius: 9px;
    letter-spacing: 0.045em;
    background: #3570e6;
    color: #fff;
    box-shadow: 0 2.5px 15px 0 #2d59d32e;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 13px;
    transition: background .14s, box-shadow .14s;
  }
  .filter-btn:hover,
  .filter-btn:focus {
    background: #2554b3;
    color: #fff;
    box-shadow: 0 4.5px 16px 0 #2a468930;
  }
  @media (max-width: 1000px) {
    .modal-container { max-width: 99vw; }
    .modal-header-area { padding: 15px 11px 8px 14px; }
    .header-title { font-size: 17px; }
    .modal-body-content { padding: 18px 7px 24px 7px; }
    .filter-btn { margin-top: 15px; }
  }
`

function getStringDate(date:any) {
  if (!date) return ''
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  const dayFormatted = day < 10 ? '0' + day : day.toString()
  const monthFormatted = month < 10 ? '0' + month : month.toString()
  return `${year}-${monthFormatted}-${dayFormatted}`
}

function applyMask(value, mask) {
  if (!value) return ''

  if (mask === 'cpf') {
    const digits = value.replace(/\D/g, '')
    return digits
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2')
      .substr(0, 14)
  }

  if (mask === 'cnpj') {
    // aceita letras e números, mantém o padrão AA.AAA.AAA/AAAA-DV
    // (12 primeiras alfanuméricas; DV numérico)
    const raw = value.toUpperCase().replace(/[^0-9A-Z]/g, '')
    const first12 = raw.slice(0, 12)
    const dv = raw.slice(12, 14).replace(/[^0-9]/g, '') // DV só números
    const clean = (first12 + dv).slice(0, 14)

    const p1 = clean.slice(0, 2)
    const p2 = clean.slice(2, 5)
    const p3 = clean.slice(5, 8)
    const p4 = clean.slice(8, 12)
    const p5 = clean.slice(12, 14)

    let out = p1
    if (p2) out += '.' + p2
    if (p3) out += '.' + p3
    if (p4) out += '/' + p4
    if (p5) out += '-' + p5

    return out
  }

  return value
}

function unmask(value, mask) {
  if (!value) return ''
  if (mask === 'cnpj') {
    return value.toUpperCase().replace(/[^0-9A-Z]/g, '') // mantém letras
  }
  return value.replace(/\D/g, '') // cpf e outros numéricos
}

function normalizeSearchText(value:any) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('pt-BR')
    .trim()
}

const FilterModal = (props:any) => {
  const usesRemoteOptions = (name:string) => props.filters?.some(
    (filter:any) => filter.name === name && !filter.options?.length && !filter.optionsSource
  ) ?? false
  const usesReportFilters = ['familiaProduto', 'marca', 'grupo', 'tipoPreco', 'politicaPreco']
    .some(usesRemoteOptions)
  const reportFilters:any = useReportFilters(usesReportFilters)
  const distributors = useDistributors(usesRemoteOptions('distributors'))
  const industries = useIndustries(usesRemoteOptions('industries'))
  const industriesName = useIndustriesName(usesRemoteOptions('industriesName'))
  const regions = useRegions(usesRemoteOptions('regions'))
  const bus = useBUs(usesRemoteOptions('bu'))
  const plataformas = usePlataformas(usesRemoteOptions('plataforma'))
  const [fields, setFields] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [consumoPromoUlBus, setConsumoPromoUlBus] = useState<any[]>([])
  const [searchInputs, setSearchInputs] = useState<Record<string, string>>({})

  useEffect(() => {
    if (!props.filters?.some((filter:any) => filter.optionsSource === 'consumoPromoUlBus')) return

    let active = true
    API.getConsumoPromoUlBusinessUnits()
      .then((response:any) => {
        if (!active) return
        const rows = Array.isArray(response?.data) ? response.data : []
        const values = rows
          .map((row:any) => Array.isArray(row) ? row[0] : row?.BU)
          .filter((value:any) => value !== null && value !== undefined && String(value).trim() !== '')
          .map((value:any) => String(value).trim())
        const uniqueValues = Array.from(new Set(values)) as string[]
        setConsumoPromoUlBus(uniqueValues.map((value) => ({value, label: value})))
      })
      .catch((error:any) => console.error('Erro ao carregar BUs do relatório Consumo Promo UL:', error))

    return () => {
      active = false
    }
  }, [props.filters])

  function getOptions(filter:any) {
    if (filter.options && filter.options.length) return filter.options
    if (filter.optionsSource && props.optionSources?.[filter.optionsSource]) return props.optionSources[filter.optionsSource]
    if (filter.optionsSource === 'consumoPromoUlBus') return consumoPromoUlBus
    if (filter.name === 'distributors') return distributors
    if (filter.name === 'regions') return regions
    if (filter.name === 'industries') return industries
    if (filter.name === 'industriesName') return industriesName
    if (filter.name === 'bu') return bus
    if (filter.name === 'familiaProduto') return reportFilters.familia
    if (filter.name === 'marca') return reportFilters.marcas
    if (filter.name === 'grupo') return reportFilters.grupo
    if (filter.name === 'tipoPreco') return reportFilters.tipoPrecos
    if (filter.name === 'politicaPreco') return reportFilters.politicaPreco
    if (filter.name === 'plataforma') return plataformas
    if (filter.name === 'tipoVenda') return [{value:'Assistida', label:'Assistida'}, {value:'Orgânica', label:'Orgânica'}]
    if (filter.name === 'canalVendas') return [
      {value:'DESKTOP', label:'DESKTOP'}, 
      {value:'WHATSAPP', label:'WHATSAPP'},
      {value:'APP ANDROID', label:'APP ANDROID'},
      {value:'APP IOS', label:'APP IOS'},
      {value:'CHATBOT ICE', label:'CHATBOT ICE'},
      {value:'NÃO IDENTIFICADO', label:'NÃO IDENTIFICADO'},
      {value:'MOBILE', label:'MOBILE'},
      {value:'WEDUU', label:'WEDUU'},
      {value:'APP ICE ANDROID', label:'APP ICE ANDROID'},
      {value:'APP ICE IOS', label:'APP ICE IOS'}
    ];
    if (filter.name === 'UF') return [
      { value: 'AC', label: 'AC' },
      { value: 'AL', label: 'AL' },
      { value: 'AP', label: 'AP' },
      { value: 'AM', label: 'AM' },
      { value: 'BA', label: 'BA' },
      { value: 'CE', label: 'CE' },
      { value: 'DF', label: 'DF' },
      { value: 'ES', label: 'ES' },
      { value: 'GO', label: 'GO' },
      { value: 'MA', label: 'MA' },
      { value: 'MT', label: 'MT' },
      { value: 'MS', label: 'MS' },
      { value: 'MG', label: 'MG' },
      { value: 'PA', label: 'PA' },
      { value: 'PB', label: 'PB' },
      { value: 'PR', label: 'PR' },
      { value: 'PE', label: 'PE' },
      { value: 'PI', label: 'PI' },
      { value: 'RJ', label: 'RJ' },
      { value: 'RN', label: 'RN' },
      { value: 'RS', label: 'RS' },
      { value: 'RO', label: 'RO' },
      { value: 'RR', label: 'RR' },
      { value: 'SC', label: 'SC' },
      { value: 'SP', label: 'SP' },
      { value: 'SE', label: 'SE' },
      { value: 'TO', label: 'TO' },
    ];
    if (filter.name === 'perfil') return [
      { value: 'Seller', label: 'Seller' },
      { value: 'Indústria', label: 'Indústria' },
    ];
    if (filter.name === 'sellerGroupAprov') return [
      { value: 'Aprovado', label: 'Aprovado' },
      { value: 'Rejeitado', label: 'Rejeitado' },
      { value: 'Pendente', label: 'Pendente' },
    ];
    return []
  }

  useEffect(() => {
    const initialData:any = {}
    props.filters.forEach((f:any) => {
      const val = props.data && props.data[f.name] !== undefined ? props.data[f.name] : undefined
      if (f.type === 'date') {
        if (val) {
          const [y, m, d] = (val as string).split('-').map(Number)
          initialData[f.name] = new Date(y, m - 1, d)
        } else {
          initialData[f.name] = f.defaultToday === false ? null : new Date()
        }
      } else if (f.type === 'dropdown' || f.type === 'select' || f.type === 'autocomplete') {
        const opts = getOptions(f)
        if (val !== undefined && val !== null) {
          if (f.isMulti && Array.isArray(val)) {
            initialData[f.name] = val.map((v:any) => opts.find((o:any) => o.value === v)).filter(Boolean)
          } else {
            initialData[f.name] = opts.find((o:any) => o.value === val) || null
          }
        } else {
          initialData[f.name] = f.isMulti ? [] : null
        }
      } else if (f.type === 'radio') {
        initialData[f.name] = props.data && props.data[f.name] !== undefined ? props.data[f.name] : (f.default || (f.options?.[0]?.value ?? ''))
      } else if (f.type === 'text' && f.mask) {
        initialData[f.name] = val ? applyMask(val.toString(), f.mask) : ''
      } else {
        initialData[f.name] = props.data && props.data[f.name] !== undefined ? props.data[f.name] : ''
      }
    })
    setFields(initialData)
    setLoading(false)
  }, [props.filters, props.data, props.optionSources, distributors, industries, regions, bus, consumoPromoUlBus])

  const uniqueFilters = useMemo(() => {
    const seen = new Set<string>()
    return props.filters.filter((f:any) => {
      if (seen.has(f.name)) return false
      seen.add(f.name)
      return true
    })
  }, [props.filters])

  const visibleFilters = useMemo(() => {
    return uniqueFilters.filter((f:any) => {
      if (f.showIf) {
        const conds = Array.isArray(f.showIf) ? f.showIf : [f.showIf]
        return conds.every((c:any) => fields[c.field] === c.value)
      }
      if (f.hideIf) {
        const conds = Array.isArray(f.hideIf) ? f.hideIf : [f.hideIf]
        return conds.every((c:any) => fields[c.field] !== c.value)
      }
      return true
    })
  }, [uniqueFilters, fields])

  function getData() {
    const data:any = {}
    console.log(props.filters);
    props.filters.forEach((f:any) => {
      if (f.type === 'date') {
        data[f.name] = getStringDate(fields[f.name])
      } else if (f.type === 'dropdown' || f.type === 'select' || f.type === 'autocomplete') {
        if (f.isMulti) {
          data[f.name] = Array.isArray(fields[f.name]) ? fields[f.name].map((opt:any) => opt.value) : []
        } else {
          data[f.name] = fields[f.name]?.value ?? ''
        }
      } else if (f.type === 'text' && f.mask) {
        data[f.name] = unmask(fields[f.name], f.mask)
      } else {
        data[f.name] = fields[f.name]
      }
    })
    console.log(data);
    return data
  }

  function renderField(filter:any) {
    switch (filter.type) {
      case 'date':
        return (
          <div key={filter.name} className='form-group'>
            <label className='form-label'>{filter.label}</label>
            <DatePicker
              disabled={loading}
              dateFormat='dd/MM/yyyy'
              selected={fields[filter.name]}
              onChange={(date:any) => setFields((f:any) => ({ ...f, [filter.name]: date }))}
              className='form-input'
              minDate={filter.minDate}
              maxDate={filter.maxDate}
              placeholderText={filter.placeholder}
              required={filter.required}
              isClearable={filter.clearable}
            />
          </div>
        )
      case 'text':
  if (filter.mask) {
    return (
      <div key={filter.name} className='form-group'>
        <label className='form-label'>{filter.label}</label>
        <input
          className='form-input'
          type='text'
          disabled={loading}
          value={fields[filter.name]}
          onChange={(e) => {
            const masked = applyMask(e.target.value, filter.mask)
            setFields((f: any) => ({ ...f, [filter.name]: masked }))
          }}
          // Sem onPaste: o onChange já aplica a máscara ao valor colado
          placeholder={filter.placeholder}
          required={filter.required}
          autoComplete='off'
        />
      </div>
    )
  }
  return (
    <div key={filter.name} className='form-group'>
      <label className='form-label'>{filter.label}</label>
      <input
        className='form-input'
        type='text'
        disabled={loading}
        value={fields[filter.name]}
        onChange={(e) => setFields((f: any) => ({ ...f, [filter.name]: e.target.value }))}
        // Sem onPaste: comportamento nativo funciona corretamente
        placeholder={filter.placeholder}
        required={filter.required}
        autoComplete='off'
      />
    </div>
  )
      case 'autocomplete': {
        const inputValue = searchInputs[filter.name] || ''
        const minChars = Number(filter.minChars || 2)
        const normalizedInput = normalizeSearchText(inputValue)
        const isLoadingOptions = Boolean(props.loadingOptionSources?.[filter.optionsSource])
        const options = normalizedInput.length >= minChars
          ? getOptions(filter)
              .filter((option:any) => normalizeSearchText(option.label).includes(normalizedInput))
              .slice(0, Number(filter.maxOptions || 50))
          : []

        return (
          <div key={filter.name} className='form-group'>
            <label className='form-label'>{filter.label}</label>
            <Select
              isDisabled={loading || isLoadingOptions}
              isLoading={isLoadingOptions}
              isClearable
              options={options}
              value={fields[filter.name]}
              inputValue={inputValue}
              placeholder={isLoadingOptions ? 'Carregando cidades...' : (filter.placeholder || 'Digite para pesquisar')}
              menuIsOpen={!isLoadingOptions && normalizedInput.length >= minChars}
              onInputChange={(value, actionMeta) => {
                if (actionMeta.action === 'input-change') {
                  setSearchInputs((current:any) => ({...current, [filter.name]: value}))
                } else if (actionMeta.action === 'set-value' || actionMeta.action === 'menu-close') {
                  setSearchInputs((current:any) => ({...current, [filter.name]: ''}))
                }
              }}
              onChange={(selected) => setFields((current:any) => ({...current, [filter.name]: selected}))}
              noOptionsMessage={() => {
                if (normalizedInput.length < minChars) {
                  return `Digite pelo menos ${minChars} caracteres`
                }
                return 'Nenhuma cidade encontrada'
              }}
              filterOption={() => true}
              className='multi-select'
              classNamePrefix='react-select'
              styles={{
                control: (styles) => ({
                  ...styles,
                  borderColor: '#d9e4fd',
                  minHeight: '38px',
                  borderRadius: 7,
                  background: '#f6fafd'
                }),
                menu: (styles) => ({...styles, zIndex: 2000, borderRadius: 8})
              }}
            />
          </div>
        )
      }

      case 'dropdown':
      case 'select':
        return (
          <div key={filter.name} className='form-group'>
            <label className='form-label'>{filter.label}</label>
            <Select
              isMulti={filter.isMulti}
              isDisabled={loading}
              options={getOptions(filter)}
              value={fields[filter.name]}
              placeholder={filter.placeholder || 'Selecione ' + filter.label}
              onChange={(selected) => setFields((f:any) => ({ ...f, [filter.name]: selected }))}
              className='multi-select'
              classNamePrefix='react-select'
              isSearchable={filter.type === 'dropdown'}
              styles={{
                control: (styles) => ({
                  ...styles,
                  borderColor: '#d9e4fd',
                  minHeight: '38px',
                  borderRadius: 7,
                  background: '#f6fafd'
                }),
                menu: (styles) => ({ ...styles, zIndex: 2000, borderRadius: 8 })
              }}
            />
          </div>
        )
      case 'radio':
        return (
          <div key={filter.name} className='form-group'>
            <label className='form-label'>{filter.label}</label>
            <div className='radio-row'>
              {filter.options.map((opt:any) => (
                <div className='radio-item' key={opt.value}>
                  <input
                    className='form-check-input'
                    type='radio'
                    name={filter.name}
                    id={`${filter.name}_${opt.value}`}
                    value={opt.value}
                    checked={fields[filter.name] === opt.value}
                    onChange={() => setFields((f:any) => ({ ...f, [filter.name]: opt.value }))}
                  />
                  <label htmlFor={`${filter.name}_${opt.value}`}>{opt.label}</label>
                </div>
              ))}
            </div>
          </div>
        )
      case 'empty':
        return (
          <div  className='form-group'></div>
        )
      default:
        return null
    }
  }

  return (
    <Style>
        <div className='modal-header-area'>
          <span className='header-title'>
            <FiFilter size={22} /> Filtros para o relatório
          </span>
          <BtnClose onClick={() => props.onClose()} />
        </div>
        <div className='modal-body-content'>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setLoading(true);
              props.onApply(getData())
            }}
            autoComplete='off'
          >
            <div className='form-fields-grid'>
              {visibleFilters.map(renderField)}
            </div>
            <button
              type='submit'
              className='filter-btn'
              disabled={loading}
            >
              <FiFilter size={19} style={{ marginBottom: -2 }} />
              {!loading && 'Filtrar'}
              {loading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Aguarde...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </form>
        </div>
    </Style>
  )
}

export default FilterModal